<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('purchaseSaleInventory.pageTitle') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('purchaseSaleInventory.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <ts-card>
                        <ts-card-wrapper>
                            <ts-loading-banner :loading="loading">
                                <form>
                                    <fieldset>
                                        <legend>{{ $t('purchaseSaleInventory.criteria') }}</legend>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="required">{{
                                                        $t('purchaseSaleInventory.date')
                                                    }}</label>
                                                    <a-range-picker style="width: 100%" :mode="mode" format="MM-YYYY"
                                                        v-model="month_range" valueFormat="MM-YYYY"
                                                        @panelChange="handlePanelChange" @change="dateChange" />
                                                    <div class="validate" v-if="errors.has('date_range')">
                                                        {{ errors.first('date_range') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col md-12">
                                                <label>{{ $t('purchaseSaleInventory.branch') }}</label>
                                                <a-select style="width: 100%; font-size: 15px" mode="multiple"
                                                    placeholder="All" :filterOption="(input, option) =>
                                                        option.componentOptions.children[0].text
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                        " v-model="model.branch_id" :options="branchList"
                                                    @change="onChangeBranch"></a-select>
                                                <div class="validate" v-if="errors.has('branch_id')">
                                                    {{ errors.first('branch_id') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>{{ $t('purchaseSaleInventory.location') }}</label>
                                                    <a-select v-model="model.location_id" mode="multiple"
                                                        :defaultActiveFirstOption="true" showSearch :filterOption="(input, option) =>
                                                            option.componentOptions.children[0].text
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                            " :options="locations" :placeholder="$t('all')"
                                                        class="ts-w-full"></a-select>
                                                    <div class="validate" v-if="errors.has('location_id')">
                                                        {{ errors.first('location_id') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <label>
                                                    {{ $t('purchaseSaleInventory.category') }}
                                                </label>
                                                <a-select style="width: 100%" mode="multiple" placeholder="All"
                                                    :filterOption="(input, option) =>
                                                        option.componentOptions.children[0].text
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                        " v-model="model.category_id" :options="categories"
                                                    @change="fetchProductGroup"></a-select>
                                                <div class="validate" v-if="errors.has('category_id')">
                                                    {{ errors.first('category_id') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <label>
                                                    {{ $t('purchaseSaleInventory.productGroup') }}
                                                </label>
                                                <a-select style="width: 100%" mode="multiple" placeholder="All"
                                                    :filterOption="(input, option) =>
                                                        option.componentOptions.children[0].text
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                        " v-model="model.product_group_id" :options="productGroups"
                                                    @change="fetchProduct()"></a-select>
                                                <div class="validate" v-if="errors.has('product_id')">
                                                    {{ errors.first('product_id') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <label>
                                                    {{ $t('purchaseSaleInventory.product') }}
                                                </label>
                                                <a-select style="width: 100%" mode="multiple" placeholder="All"
                                                    :filterOption="(input, option) =>
                                                        option.componentOptions.children[0].text
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                        " v-model="model.product_id" :options="products"
                                                    @search="handleSearchProduct"></a-select>
                                                <div class="validate" v-if="errors.has('product_id')">
                                                    {{ errors.first('product_id') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-md-12">
                                                <label class="required">{{
                                                    $t('purchaseSaleInventory.type')
                                                }}</label>
                                                <a-select style="width: 100%" v-model="model.report_type"
                                                    :options="amountType">
                                                </a-select>
                                                <div class="validate" v-if="errors.has('type')">
                                                    {{ errors.first('type') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 text-right">
                                                <ts-button class="btn-block" outline color="success"
                                                    :waiting="exporting" @click.prevent="exportExcel"><i
                                                        class="fas fa-file-excel"></i>
                                                    {{ $t('excel') }}</ts-button>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <ts-button class="btn-block" color="primary" :waiting="waiting"
                                                    @click.prevent="preview"><i class="fas fa-file-pdf text-red"></i>
                                                    {{ $t('preview') }}</ts-button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </ts-loading-banner>
                        </ts-card-wrapper>
                    </ts-card>
                </div>
            </div>
            <div class="col-md-9">
                <ts-card>
                    <ts-card-wrapper>
                        <form>
                            <fieldset>
                                <legend>{{ $t('yearlySoldBySaleType.preview') }}</legend>
                                <ts-preview-pdf v-model="waiting" :src="src" />
                            </fieldset>
                        </form>
                    </ts-card-wrapper>
                </ts-card>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { debounce,trim } from 'lodash'
import { mapActions } from 'vuex';
import * as FileDownload from 'downloadjs'

export default {
    name: 'purchaseSaleInventory',
    data() {
        return {
            loading: false,
            errors: new Errors(),
            waiting: false,
            exporting: false,
            src: null,
            mode: ['month', 'month'],
            month_range: [moment().startOf('year'), moment().endOf('year')],
            branchList: [],
            locations: [],
            categories: [],
            productGroups: [],
            products: [],
            model: {
                month_range: [
                    moment().startOf('year').format('MM-YYYY'),
                    moment().endOf('year').format('MM-YYYY')
                ],
                branch_id: [],
                location_id: undefined,
                category_id: undefined,
                pro_group_id: undefined,
                product_id: undefined,
                report_type: 'AMT',
            },
        }
    },
    created() {
        this.fetchData()
    },
    computed: {
        amountType() {
            return [
                { value: 'AMT', label: 'Amount' },
                { value: 'QTY', label: 'Qty' }
            ]
        }
    },
    methods: {
        ...mapActions('report/finance', ['purchaseSaleInventory','purchaseSaleInventoryExcel']),
        handleSearchProduct: debounce(async function (value) {
            if (!value) return false
            this.fetchProduct(value)
        }, 500),
        handlePanelChange(value, mode) {
            this.month_range = value
            this.model.month_range[0] = moment(value[0]).format('MM-YYYY')
            this.model.month_range[1] = moment(value[1]).format('MM-YYYY')
            this.mode = [
                mode[0] === 'date' ? 'month' : mode[0],
                mode[1] === 'date' ? 'month' : mode[1]
            ]
        },
        dateChange(value) {
            this.month_range = value
            this.model.month_range[0] = value[0]
            this.model.month_range[1] = value[1]
        },
        async fetchData() {
            this.loading = true
            await this.$store
                .dispatch('security/user/getBranchAssigned')
                .then(response => {
                    this.branchList = response.data.map(el => ({
                        value: el.branch_id,
                        label: el.branch_name_en
                    }))
                    this.model.branch_id =
                        this.$store.state.authUser.user.default_branch.branch_id
                    this.onChangeBranch()
                })

            await this.$store
                .dispatch('report/resource/productCategory')
                .then(response => {
                    this.categories = response.data.map(el => ({
                        value: el.category_id,
                        label: el.category_name_en
                    }))
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onChangeBranch() {
            this.locationLoading = true
            this.locations = []
            this.model.location_id = undefined
            this.$store
                .dispatch('report/resource/getLocation', {
                    branch_id: this.model.branch_id
                })
                .then(response => {
                    this.locations = response.data.map(el => ({
                        value: el.location_id,
                        label: el.location_name_en
                    }))
                })
                .finally(() => {
                    this.locationLoading = false
                })
        },
        fetchProductGroup() {
            this.model.product_group_id = undefined
            this.model.product_id = undefined
            this.loading = true
            this.$store
                .dispatch('report/resource/productGroup', {
                    filter: {
                        category_id: _.join(this.model.category_id, ',')
                    }
                })
                .then(response => {
                    this.productGroups = response.data.map(el => ({
                        value: el.pro_group_id,
                        label: el.pro_group_name_en
                    }))
                    this.fetchProduct()
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fetchProduct(value) {
            this.model.product_id = undefined
            this.loading = true
            this.$store
                .dispatch('report/resource/productProfileLocation', {
                    filter: {
                        search: value,
                        pro_group_id: _.join(this.model.product_group_id, ','),
                        category_id: _.join(this.model.category_id, ',')
                    }
                })
                .then(response => {
                    this.products = response.data.map(el => ({
                        value: el.product_id,
                        label: el.product_name_en
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        preview() {
            this.waiting = true
            this.src = ''
            this.errors = new Errors()
            this.purchaseSaleInventory(this.model)
                .then(response => {
                    this.src = response.url
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        exportExcel() {
            this.exporting = true
            this.errors = new Errors()
            this.purchaseSaleInventoryExcel(this.model)
                .then(response => {
                    let filename = trim(
                        response.headers['content-disposition']
                            .substring(
                                response.headers['content-disposition'].indexOf('filename')
                            )
                            .replace('filename=', ''),
                        '"'
                    )
                    FileDownload(response.data, filename)
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    )
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => (this.exporting = false))
        }

    }
}
</script>